export default __webpack_public_path__ + "static/media/maintenance_icon.73b096ee.png";